var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSelectWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25,
    height: 15,
    viewBox: "0 0 25 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-icon-select"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 15
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-select",
    clipPath: "url(#clip-icon-select)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "open1",
    width: 15,
    height: 15,
    transform: "translate(15) rotate(90)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2506",
    "data-name": "Path 2506",
    d: "M4.065,6.585a.252.252,0,0,1,0,.392L.4,11.277a1.647,1.647,0,0,0,.129,2.284s4.854-5.7,4.887-5.755a1.766,1.766,0,0,0,.169-.322,1.878,1.878,0,0,0,0-1.407,1.766,1.766,0,0,0-.169-.322C5.382,5.7.528,0,.528,0A1.647,1.647,0,0,0,.4,2.284Z",
    transform: "translate(14.47 4.576) rotate(90)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSelectWhite);
export default __webpack_public_path__ + "static/media/icon-select-white.bfbcd3ba04ddb927d783e9306de9d5a4.svg";
export { ForwardRef as ReactComponent };